import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable, of} from "rxjs";
import {catchError} from "rxjs/operators";
import {environment} from "../../../environments/environment";
import {DocumentResult} from "../../models/document-result";
import Helpers from "../../utils/helpers";

@Injectable()
export class DocumentResultControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public getAllResults(serviceId: string): Observable<DocumentResult[]> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/document_result") as Observable<DocumentResult[]>;
  }

  public getRegistrationResults(registrationId: string): Observable<DocumentResult[]> {
    return this.http.get(this.baseUrl + "registration/" + registrationId + "/document_result") as Observable<DocumentResult[]>;
  }

  public addRegistrationResult(registrationId: string, documentResult: DocumentResult) {
    Helpers.trimRecursiveObj(documentResult);
    const body = JSON.stringify(documentResult);
    return this.http.post(this.baseUrl + "registration/" + registrationId + "/document_result", body);
  }

  public getRegistrationResult(documentResultId: string) {
    return this.http.get(this.baseUrl + "document_result/" + documentResultId);
  }

  public saveRegistrationResult(documentResult: DocumentResult) {
    Helpers.trimRecursiveObj(documentResult);
    const body = JSON.stringify(documentResult);
    return this.http.put(this.baseUrl + "document_result", body, {responseType: "text"});
  }

  public deleteRegistrationResult(documentResultId: string) {
    return this.http.delete(this.baseUrl + "document_result/" + documentResultId, {responseType: "text"});
  }

  public updateLinkingFileUploadPath(id: string, newValue: string) {
    const body = { linkingFileUploadPath: newValue };
    return this.http.patch(this.baseUrl + "document_result/" + id + "/linking_file_upload_path", body).pipe(
      catchError((error) => {
        if (error.status === 404) {
          return of(null);
        }
        throw error;
      })
    );
  }

  public updateSortOrder(documentResults: DocumentResult[]) {
    const body = JSON.stringify(documentResults);
    return this.http.put(this.baseUrl + "sort_document_results", body, {responseType: "text"});
  }
}
